module.exports = __webpack_public_path__ + "media/bloque esperar.fe9d35e2.mp4";